import { Box } from "rebass";
import { getLocalizedString } from "../../utils";

const CatalogueCount = ({ catalogue, totalCount, sx, ...props }) => {
  return (
    <Box
      padding={["2px", "8px"]}
      fontSize={[".8em", ".9em"]}
      sx={{
        borderBottom: "1px solid",
        borderColor: ["transparent", "#f2f2f2"],
        ...sx,
      }}
      {...props}
    >
      {catalogue?.length && totalCount
        ? `1-${catalogue?.length} ${getLocalizedString(
            "CATALOGUE_COUNT",
          )} ${totalCount}`
        : `0 ${getLocalizedString("CATALOGUE_COUNT")} ${totalCount}`}
      &nbsp;
      {getLocalizedString(
        totalCount === 1 ? "CATALOGUE_ITEMS_SINGLE" : "CATALOGUE_ITEMS",
      )}
    </Box>
  );
};

export default CatalogueCount;
